export const REFRESH_TOKEN_DELAY = 180000;
